import React, { useState, useEffect } from 'react'
import {
  Panel,
  Form,
  Button,
  Radio,
  RadioGroup,
  Row,
  Col,
  Message,
  ControlLabel,
  Input,
  Checkbox,
} from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import CustomIconMessageInfo from '../CustomIconMessageInfo'
import { startLoading, doneLoading } from '../../utils/loading'
import InputForm from '../../components/forms/input/InputForm'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { useParams, useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getRequiredData,
} from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import classNames from 'classnames'
import NumberFormat from 'react-number-format'
import { budgetFormat } from '../../utils/formatterUtil'
import AttachFilesForm from '../attachfiles/AttachFilesForm'
import AttachFilesView from '../attachfiles/AttachFilesView'
import { isEmpty } from 'lodash-es'
import {
  contractCenterApproveCloseOfProject,
  secureApproveCloseOfProject,
} from '../../redux/actions/closeOfProject'
import { downloadFile, previewFile } from '../../utils/fileUtil'
import notification from '../../utils/notification'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import EditButton from '../../components/buttons/editButton/EditButton'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'

export default function CloseProjectApproveWidget({ schema: _schema, ...props }) {
  const { showCommandButton, isEditAll, isApprove } = props
  const [isEdit, setIsEdit] = useState(false)
  const [isError, setIsError] = useState(false)
  const [section, setSection] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [request, setRequest] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(_schema)
  const [closeTypeSelected, setCloseTypeSelected] = useState(_schema?.closeType?.value)
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [uploadError, setUploadError] = useState(false)
  const [deleteError, setDeleteError] = useState()
  const [renameError, setRenameError] = useState()
  const [isErrorFileList, setIsErrorFileList] = useState(false)
  const [approveError, setApproveError] = useState('')
  const [sendToGranteeVal, setSendToGranteeVal] = useState(false)

  useEffect(() => {
    setIsEdit(isEditAll)
  }, [isEditAll])

  const onSubmit = (data) => {
    console.log('onSubmit data', data)

    let request = {
      projectVersionId: projectId,
      note: data[formSchema.note.name],
      approveType: data[formSchema.approveType?.name] || 0,
      sendToGrantee: data.approveType == 2 ? true : sendToGranteeVal,
      noteSendToGrantee: data?.note || '',
    }

    setRequest(request)
    console.log('request', request)
    setIsShowConfirm(true)
  }

  const handleCallService = async () => {
    setIsLoading(true)
    startLoading()
    setIsError(false)
    setApproveError('')
    try {
      //const response = await contractCenterApproveCloseOfProject(projectId, request)
      const response = await secureApproveCloseOfProject(projectId, request)
      console.log('response', response)

      if (response.success) {
        if (response.secureApprovalUri) {
          console.log('go secure approve')
          doneLoading()
          window.location.href = response.secureApprovalUri
        } else {
          setIsError(false)
          setIsShowConfirm(false)
          doneLoading()
          setIsLoading(false)
          setApproveError('')
          // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      } else {
        setIsShowConfirm(false)
        setApproveError(response.error)
      }
    } catch (e) {
      if (e?.response?.data?.errors?.message) {
        setApproveError(e?.response?.data?.errors?.message)
      } else {
        setApproveError('บันทึกไม่สำเร็จ กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
      }
    }
    setIsShowConfirm(false)
    doneLoading()
    setIsLoading(false)
  }

  const onConfirm = () => {
    console.log('onConfirm', request)
    handleCallService()
    setIsShowConfirm(false)
  }

  const onCancle = () => {
    console.log('onCancle')

    setRequest()
    setIsShowConfirm(false)
  }

  return (
    <>
      {isLoading && <OverlayLoader />}
      <Panel
        shaded
        header={formSchema.header}
        eventKey={2}
        collapsible
        defaultExpanded
        ref={(section) => {
          setSection(section)
        }}
      >
        {formSchema.approverCommentList?.length > 0 && (
          <>
            {formSchema.approverCommentList.map((item, index) => {
              return (
                <Message
                  key={index}
                  type={'info'}
                  description={`${item.employeeName} : ${item.descriptionSummary}`}
                />
              )
            })}
            <br />
          </>
        )}

        {formSchema?.note &&
          (showCommandButton ? (
            <>
              <ControlLabel
                className={classNames(
                  'style-text-lable',
                  isRequired(formSchema.note.validators) && 'required'
                )}
              >
                {formSchema.note.label}
              </ControlLabel>

              {!formSchema.approveType && (
                <Checkbox
                  defaultChecked={formSchema?.sendToGrantee?.value || sendToGranteeVal}
                  onChange={(_, checked, e) => {
                    console.log('checked ', checked)
                    setSendToGranteeVal(checked)
                  }}
                >
                  {formSchema?.sendToGrantee?.label}
                </Checkbox>
              )}

              <ErrorMessage error={errors[formSchema.note.name]} />
              <Input
                name={formSchema.note.name}
                inputRef={register(isValidators(formSchema.note.validators))}
                rows={3}
                placeholder={formSchema.note.hint}
                componentClass="textarea"
                defaultValue={formSchema.note.value}
                disabled={formSchema?.noteSendToGrantee?.disabled}
              />
            </>
          ) : (
            <>
              <p>{formSchema.note.label}</p>
              <p style={{ textIndent: '2.5em' }}>{formSchema.note.value}</p>
            </>
          ))}

        {formSchema.approveType && (
          <>
            <br />
            <ErrorMessage error={errors[formSchema.approveType.name]} />
            <Controller
              key={formSchema.approveType.name}
              name={formSchema.approveType.name}
              control={control}
              rules={isValidators(formSchema.approveType.validators)}
              defaultValue={formSchema.approveType.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {formSchema.approveType?.options?.map((item) => {
                      return (
                        <Radio value={item.value} disabled={formSchema.disabled}>
                          {item.label}{' '}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
          </>
        )}

        {showCommandButton && (
          <>
            <hr />

            {approveError && <Message showIcon type="error" description={approveError} />}
            {sendToGranteeVal ? (
              <EditButton
                icon="send"
                onClick={handleSubmit(onSubmit)}
                children={formSchema?.sendToGrantee?.buttonText}
              />
            ) : (
              <SaveButton onClick={handleSubmit(onSubmit)} children={formSchema.buttonText} />
            )}
          </>
        )}

        <ConfirmWidget
          title={`ยืนยันการ${
            sendToGranteeVal ? formSchema?.sendToGrantee?.buttonText : formSchema.buttonText
          }`}
          show={isShowConfirm}
          detail={`กรุณายืนยันการ${
            sendToGranteeVal ? formSchema?.sendToGrantee?.buttonText : formSchema.buttonText
          }`}
          onCancle={onCancle}
          onConfirm={onConfirm}
        />
      </Panel>
    </>
  )
}
